import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarginBarComponent } from './margin-bar.component';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';

@NgModule({
    declarations: [MarginBarComponent],
    imports: [CommonModule, TooltipModule],
    exports: [MarginBarComponent],
})
export class MarginBarModule {}
